var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"toggle btn\" ng-class=\"wrapperClass\" ng-style=\"wrapperStyle\" ng-click=\"onSwitch()\"><div class=\"toggle-group\"><label class=\"btn\" ng-class=\"onClass\"></label> <label class=\"btn active\" ng-class=\"offClass\"></label> <span class=\"btn btn-default\" ng-class=\"handleClass\"></span></div></div>";
var id1="toggle.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;